export default __webpack_public_path__ + "static/media/drag-icon.8e1403ff.svg";